import { UseFormRegisterReturn } from 'react-hook-form';

import { HiddenInput, Root, Switcher } from './Switch.ui';

type SwitchProps = UseFormRegisterReturn;

export const Switch = (props: SwitchProps) => {
  return (
    <Root>
      <HiddenInput {...props} type="checkbox" tabIndex={0} />

      <Switcher />
    </Root>
  );
};
